import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatInputModule} from '@angular/material/input';
import {MatDialogModule} from '@angular/material/dialog';
import {MatMenuModule} from '@angular/material/menu';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSelectModule} from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatStepperModule} from '@angular/material/stepper';
import {SwiperModule, SWIPER_CONFIG, SwiperConfigInterface} from 'ngx-swiper-wrapper';
import { HomeComponent } from './pages/home/home.component';
import { TeamComponent } from './pages/home/components/team/team.component';
import { HomeSliderComponent } from './pages/home/components/home-slider/home-slider.component';
import {MatRippleModule} from '@angular/material/core';
import { ContactComponent } from './pages/contact/contact.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { JobsComponent } from './pages/jobs/jobs.component';
import { JobComponent } from './pages/job/job.component';
import { AdvicesComponent } from './pages/advices/advices.component';
import { ServicesComponent } from './pages/services/services.component';
import { ApplicationComponent } from './pages/application/application.component';
import { LoginComponent } from './pages/login/login.component';
import { RegisterComponent } from './pages/register/register.component';
import { FeedbackDialogComponent } from './components/feedback-dialog/feedback-dialog.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { ResumeComponent } from './pages/resume/resume.component';
const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    TeamComponent,
    HomeSliderComponent,
    ContactComponent,
    JobsComponent,
    JobComponent,
    AdvicesComponent,
    ServicesComponent,
    ApplicationComponent,
    LoginComponent,
    RegisterComponent,
    FeedbackDialogComponent,
    ProfileComponent,
    ResumeComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatIconModule,
    MatButtonModule,
    MatButtonToggleModule,
    HttpClientModule,
    SwiperModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatSelectModule,
    MatRippleModule,
    MatCardModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatMenuModule,
    MatExpansionModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatAutocompleteModule,
    FormsModule,
    MatStepperModule,
    MatCheckboxModule
  ],
  providers: [{
    provide: SWIPER_CONFIG,
    useValue: DEFAULT_SWIPER_CONFIG
  }],
   entryComponents: [
    FeedbackDialogComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
